<template>
  <div :class="classMainContainer">
    <div :class="classFromContainer">
      <slot name="label-from" v-if="disabledLabel === false">
        <label :for="'from-' + _uid">{{ labelFrom }}: <span v-if="requiredFrom">*</span></label>
      </slot>
      <div :class="classFromInput">
        <b-datepicker
          :id="'from-' + _uid"
          :value="values.from"
          :max-date="maxFromDate"
          :show-week-number="false"
          :first-day-of-week="1"
          :editable="false"
          :required="requiredTill"
          :disabled="disabled"
          name="from"
          :placeholder="disabledLabel ? labelFrom : 'Vis kalender...'"
          icon="calendar-today"
          ref="from"
          @input="(date) => onInput(date, 'from')"
        >
          <button
            v-if="deletableFrom && !values.from"
            @click.prevent="$refs.from.toggle()"
            class="button disabled"
          >
            <span>Slett dato</span>
          </button>
          <button
            v-else-if="deletableFrom"
            @click.prevent="onDelete('from')"
            class="button"
          >
            <span>Slett dato</span>
          </button>
        </b-datepicker>
        <span class="glyph">
          <svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg>
        </span>
      </div>
    </div>
    <div :class="classTillContainer">
      <slot name="label-till" v-if="disabledLabel === false">
        <label :for="'till-' + _uid">{{ labelTill }}: <span v-if="requiredTill">*</span></label>
      </slot>
      <div :class="classTillInput">
        <b-datepicker
          :id="'till-' + _uid"
          :value="values.till"
          :min-date="minTillDate"
          :show-week-number="false"
          :editable="false"
          :first-day-of-week="1"
          :required="requiredTill"
          :disabled="disabled"
          name="till"
          :placeholder="disabledLabel ? labelTill : 'Vis kalender...'"
          icon="calendar-today"
          ref="till"
          @input="(date) => onInput(date, 'till')"
        >
          <button
            v-if="deletableTill && !values.till"
            @click.prevent="$refs.till.toggle()"
            class="button disabled"
          >
            <span>Slett dato</span>
          </button>
          <button
            v-else-if="deletableTill"
            @click.prevent="onDelete('till')"
            class="button"
          >
            <span>Slett dato</span>
          </button>
        </b-datepicker>
        <span class="glyph">
          <svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateFromTillForm',
  inject: [
    '$validator'
  ],
  props: {
    /** The model */
    value: {
      required: true
    },

    /** Labels */
    labelFrom: {
      type: String,
      default: 'Dato f.o.m:'
    },
    labelTill: {
      type: String,
      default: 'Dato t.o.m:'
    },
    disabledLabel: {
      type: Boolean,
      default: false
    },

    /** General Attr */
    requiredFrom: {
      type: Boolean,
      default: false
    },
    requiredTill: {
      type: Boolean,
      default: false
    },
    deletableFrom: {
      type: Boolean,
      default: true
    },
    deletableTill: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    /** CSS Classes */
    classMainContainer: {
      required: false,
      default: 'grid-x grid-padding-x'
    },
    classFromContainer: {
      required: false,
      default: 'cell large-6'
    },
    classTillContainer: {
      required: false,
      default: 'cell large-6'
    },
    classFromInput: {
      required: false,
      default: 'input-container'
    },
    classTillInput: {
      required: false,
      default: 'input-container'
    }
  },
  data () {
    return {
      maxFromDate: null,
      minTillDate: null,
      values: {
        from: null,
        till: null
      }
    }
  },
  created () {
    this.setDateValues()
  },
  watch: {
    value: function () {
      this.setDateValues()
    }
  },
  methods: {
    setDateValues: function () {
      // Set till and from
      this.values.from = this.value.from ? new Date(moment(this.value.from).format('YYYY-MM-DD')) : null
      this.values.till = this.value.till ? new Date(moment(this.value.till).format('YYYY-MM-DD')) : null

      // ..And calc min and max dates
      if (this.values.from && this.values.till) {
        this.maxFromDate = new Date(Date.parse(moment(this.values.till).format('YYYY-MM-DD')))
        this.minTillDate = new Date(Date.parse(moment(this.values.from).subtract(1, 'days').format('YYYY-MM-DD')))
      } else if (this.values.from) {
        this.maxFromDate = null
        this.minTillDate = new Date(Date.parse(moment(this.values.from).subtract(1, 'days').format('YYYY-MM-DD')))
      } else if (this.values.till) {
        this.maxFromDate = new Date(Date.parse(moment(this.values.till).format('YYYY-MM-DD')))
        this.minTillDate = null
      }
    },
    onInput: function (date, type) {
      const dates = {
        from: type === 'from' ? date : this.values.from,
        till: type === 'till' ? date : this.values.till
      }

      if (dates.from) {
        dates.from = moment(dates.from).format('YYYY-MM-DD')
      }

      if (dates.till) {
        dates.till = moment(dates.till).format('YYYY-MM-DD')
      }

      this.$emit('input', dates)
    },
    onDelete: function (type) {
      this.onInput(null, type)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Inputs/DateFromTillForm.vue